import { render, staticRenderFns } from "./ChangeOfShareCapital.vue?vue&type=template&id=6b2b43bf&scoped=true&"
import script from "./ChangeOfShareCapital.vue?vue&type=script&lang=js&"
export * from "./ChangeOfShareCapital.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfShareCapital.vue?vue&type=style&index=0&id=6b2b43bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b43bf",
  null
  
)

export default component.exports